import { render, staticRenderFns } from "./LessonEditor.vue?vue&type=template&id=2f5c7375&"
import script from "./LessonEditor.vue?vue&type=script&lang=js&"
export * from "./LessonEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports